import { SupplierRelationshipGetResponseType } from "@sellar-io/api-v2/types";
import { SpinnerLegacy } from "../../../../components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
} from "../../../../components/modal/Dialog";
import { useEvents } from "../../../../hooks";
import { usePriceListList } from "../../../../hooks/api/v2/priceList/usePriceListList";
import { useSupplierRelationshipUpdate } from "../../../../hooks/api/v2/supplierRelationship/useSupplierRelationshipUpdate";
import { useSellarCurrentBusiness } from "../../../../hooks/useSellarCurrentBusiness.shared";
import { EditConnectionPropertiesFragment } from "./EditConnectionPropertiesFragment";

export const ConnectionUpdateModal = ({
  onDismiss,
  connection,
  onDelete,
  active,
}: {
  onDismiss: () => void;
  onDelete: () => void;
  connection: SupplierRelationshipGetResponseType | undefined;
  active: boolean;
}) => {
  const { track } = useEvents();
  const { business } = useSellarCurrentBusiness();

  if (!business) throw new Error("Cannot find business");

  const priceTiersListQuery = usePriceListList({});

  const priceTiers = (
    priceTiersListQuery.data?.pages.flatMap((pt) => pt) ?? []
  ).filter((pt) => pt.derivationType !== "base");

  const supplierRelationshipUpdateMutate = useSupplierRelationshipUpdate(
    parseInt(connection?.id.toString() ?? ""),
  );

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title={"Edit Customer"}
      />
      <DialogContent>
        <>
          {!priceTiersListQuery.data?.pages[0]?.length ? (
            <div>
              You need to create a price tier before updating connections
            </div>
          ) : (
            <>
              {priceTiersListQuery.isLoading ||
              supplierRelationshipUpdateMutate.isPending ||
              !connection ? (
                <SpinnerLegacy />
              ) : (
                <EditConnectionPropertiesFragment
                  connection={connection}
                  buyerPostcode={
                    connection.Retailer.Business.DeliveryAddress.postalCode
                  }
                  priceTiers={priceTiers}
                  onSubmit={async (data) => {
                    supplierRelationshipUpdateMutate.mutate(data, {
                      onSuccess: () => {
                        onDismiss();
                      },
                    });
                    await track("Connection Edited");
                  }}
                  onDelete={onDelete}
                />
              )}
            </>
          )}
        </>
      </DialogContent>
    </Dialog>
  );
};
